module.exports = __webpack_public_path__ + "static/media/screenshot.29a932ad.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/projects/colonial-kart-world/screenshot.jpg
// module id = 814
// module chunks = 0